/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Connectivity_History_Day_EventsInputs */



/**
* | output |
* | --- |
* | "Events on {date}" |
*
* @param {Connectivity_History_Day_EventsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const connectivity_history_day_events = /** @type {((inputs: Connectivity_History_Day_EventsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectivity_History_Day_EventsInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Events on ${i?.date}`)
	return /** @type {LocalizedString} */ (`Événements du ${i?.date}`)
});